import React, { useEffect, useState } from 'react';
import { FilteringPage } from 'hse-filtering-library-frontend';
import { useTranslation } from 'react-i18next';
import useGetUser from '@api/user/hooks/useGetUser';
import FileType from '@constants/fileType';
import Page from '@constants/page';
import FilteringEntityType from '@constants/filteringEntityType';
import i18n from '@src/i18n';
import UploadModal from '@components/Upload/UploadModal';
import NavigationBreadcrumb from '@components/Navigation/Breadcrumb/NavigationBreadcrumb';
import CustomCellsDefinition, { ColumnName } from './CustomCellsDefinition';

function UploadListPage() {
  const [language, setLanguage] = useState(i18n.language);
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState(false);
  const { data: user } = useGetUser();

  type RowValueType = {
    [key: string]: string | number;
  };

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if (language !== i18n.language) {
      setLanguage(i18n.language);
    }
  }, [language, t]);

  const customCellRenderer = ({ rowValues, column }: { rowValues: RowValueType; column: any }) => {
    const { key } = column ?? {};
    const value = rowValues[key];
    const renderCustomCell = CustomCellsDefinition[key as ColumnName];
    if (renderCustomCell) {
      return renderCustomCell(rowValues, setRefresh);
    }
    return value;
  };

  if (!user) {
    return null;
  }

  return (
    <div className={FilteringEntityType.UPLOAD}>
      <NavigationBreadcrumb currentPage={Page.HOME} />
      <UploadModal triggerUploadsTableRefresh={setRefresh} />
      <FilteringPage
        type={FilteringEntityType.UPLOAD}
        customCellRenderer={customCellRenderer}
        additionalArgs={{
          filters: { UPLOAD_TYPE: FileType.INSPECTION_SUMMARY.key },
        }}
        defaultSort={[{ sortField: 'UPLOAD_DATE', sortDirection: 'DESC' }]}
        wrapDetailsText
        lang={language}
        showAggregations={false}
        refreshPage={refresh}
        filtersCollapsed
        renderSorting
        showHeaderTooltips={false}
        noFavorites={false}
        user={user}
        noHelpButton
      />
    </div>
  );
}

export default UploadListPage;
